import React, { Fragment } from "react";
import {
  withStyles,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Collapse,
  withTheme,
} from "@material-ui/core";
import {
  ExpandMore,
  KeyboardArrowLeft as ArrowLeft,
  KeyboardArrowRight as ArrowRight,
  Lens as DotIcon
} from "@material-ui/icons";
import {
  ToggleButton,
  ToggleButtonGroup,
} from "@material-ui/lab";
import { compose } from "recompose";
import Select from "./components/Select";
import DataSourceList from "../../../dataBinding/DataSourceList";
import DataWrapperComponent from "../../../dataBinding/DataWrapper";
import {
  generateQuickFilterString,
  iconList,
  clearFilter,
} from "../../../common/filterUtilities";
import { getSvgIcons } from "../../Dispatch/utils/iconsUtil";

import { withUserProfile } from "../../../../userProfile/userProfileContext";
import MergeObjects from "lodash/merge";
import Tooltip from "../../../common/StyledToolTip";
import appConstants from "../../../../appConstants";
import { RMAXLogger } from "../../../../services/LoggerService/RMAXLogger";
import styles from "./styles";
import TimeRange from "./components/TimeRange";
import DateRange from "./components/DateRange";
import { observer, inject } from 'mobx-react';
import { autorun } from "mobx";
import { isEqual } from "lodash/lang";

@inject('IBPlanningStore')
@observer
class QuickFilter extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      filterObject: {},
      quickFilterIsVisible: true,
      isLoading: true
    };
    this.initialWidth = this.props.glContainer.width;
    this.quickFilterList = [];
    this.autoRunAutoSelectedFilter = [];
  }

  componentDidMount() {
    this.props.glEventHub.on('toggleQuickFilterVisibility', this.toggleQuickFilterVisibility);
    this.autoRunQuickFilterList = autorun(() => {
    if (!isEqual(
      this.quickFilterList,
      this.props.IBPlanningStore.quickFilterList
    )) {
      this.quickFilterList = this.props.IBPlanningStore.quickFilterList;
      const filterGroupStates = {};
      let filterObject = {};
      this.props.IBPlanningStore.quickFilterList.map((filter) => {
        if (filter.filterJson && [null, this.props.filterName ?? ''].includes(filter.filterName)) {
          filterObject = MergeObjects(JSON.parse(filter.filterJson), filterObject);
        }
      });
      if (filterObject.filterGroups) {
        Object.keys(filterObject.filterGroups).forEach(
          (key) => (filterGroupStates[`${key}_isOpen`] = true)
        );
      }
      this.setState(
        {
          ...filterGroupStates,
          filterObject,
          isLoading: false
        },
        this.updateFilter()
      );
      this.updateAutoSelectedFilter(filterObject);
    }
  });
  this.autoRunAutoSelectedFilter = autorun(() => {
    if (!isEqual(
      this.props.IBPlanningStore.shipmentAutoSelectedFilter,
      this.autoRunAutoSelectedFilter
    )) {
      this.updateAutoSelectedFilter(this.state.filterObject);
      this.autoRunAutoSelectedFilter = this.props.IBPlanningStore.shipmentAutoSelectedFilter.slice();
    }
  });
  }

  componentWillUnmount() {
    this.props.glEventHub.off(
      "toggleQuickFilterVisibility",
      this.toggleQuickFilterVisibility
    );
   this.props.IBPlanningStore.updateShipmentAutoSelectedFilter([]);
  }

  updateAutoSelectedFilter = (filterObject) => {
    const autoSelectedFilter =  this.props.IBPlanningStore.shipmentAutoSelectedFilter;
    if (!filterObject?.filterGroups || !autoSelectedFilter?.length) return;
    const filterGroups = { ...filterObject?.filterGroups };
    autoSelectedFilter.forEach((field) => {
      // Iterate through each filter group
      for (const groupKey in filterGroups) {
        let filters = filterGroups[groupKey].filters;
        // Find the matching filter and update it
        filters = filters.map((f) => {
          if (f.actionType === 'filter' && f.label === field) {
            f['isApplied'] = true;
          }
          return f;
        });
        filterGroups[groupKey].filters = filters;
      }
    });
    this.setState({
      filterObject: {
        filterGroups
      }
    }, () => {
      this.updateFilter();
    });
  };

  // handles hide/collapse for each filter group
  toggleFilterGroupVisibility = ({ groupKey }) => {
    this.setState((state) => ({
      [`${groupKey}_isOpen`]: !state[`${groupKey}_isOpen`],
    }));
  };

  // Render toggle button for button filter and have a handler to change filter applied state
  renderButtonFilter = (filter) => {
    const { classes } = this.props;
    const filterChange = () => {
      filter.isApplied = !filter.isApplied;
      this.updateFilter();
    };
    return (
      <ToggleButton
        className={classes.toggleButton}
        key={filter.label}
        selected={filter.isApplied}
        value="filter"
        disabled={filter.isDisabled}
        title={filter.description}
        classes={{
          root: classes.toggleButtonRoot,
          disabled: classes.toggleButtonDisabled,
          selected: classes.toggleButtonSelected,
          label: classes.toggleButtonLabel,
        }}
        onClick={filterChange}
      >
        {this.getIcon(filter.icon, filter.isApplied ? "white": this.props.theme.iconColor)}
        {filter.label}
      </ToggleButton>
    );
  };

  // Render toggle buttons for toggle filter and have a handler to change filter applied state
  renderSwitchFilter = (filter) => {
    const { classes } = this.props;
    const filterChange = (event, value) => {
      const currentOption = { ...value };
      filter.options.map((option) => {
        if (option.label === currentOption.label) {
          option.isApplied = !option.isApplied;
        } else if (!currentOption.isApplied && option.isApplied) {
          option.isApplied = !option.isApplied;
        }
      });
      this.updateFilter();
    };
    return (
      <ToggleButtonGroup
        exclusive
        key={filter.options.map((option) => option.label).join("_")}
        classes={{ root: classes.toggleButtonGroupRoot }}
        onChange={filterChange}
      >
        {filter.options.map((option) => (
          <ToggleButton
            className={classes.toggleButton}
            key={option.label}
            selected={option.isApplied}
            disabled={option.isDisabled}
            title={option.description}
            value={option}
            classes={{
              root: classes.toggleButtonRoot,
              disabled: classes.toggleButtonDisabled,
              selected: classes.toggleButtonSelected,
              label: classes.toggleButtonLabel,
            }}
          >
            {option.label}
          </ToggleButton>
        ))}
      </ToggleButtonGroup>
    );
  };

  // returns icon for a filter
  getIcon = (filterIcon, color) => {
    const icon = iconList?.[filterIcon];
    if (!filterIcon || !icon) {
      return;
    }
    if (icon.isSvgIcon) {
      return (
        <span className={this.props.classes.filterIcon}>
          {getSvgIcons({ iconName: icon.iconName, backgroundColor: color })}
        </span>
      );
    }
    return <i className={`${icon.iconName} ${this.props.classes.filterIcon}`} />;
  };

  // Renders dropdown for select filter type
  renderDropdown = (filter) => {
    const filterTokens = filter.predicate.split(" ");
    let selectedValues =
      filterTokens.length > 2 ? JSON.parse(filterTokens[2]) : [];
    const dataSource = DataSourceList[filter.dataSource];
    return (
      <DataWrapperComponent
        key={filter.label}
        wrappedComponent={Select}
        componentProps={{
          textFieldProps:{
            id: filter.fieldName,
            label: filter.fieldName,
            variant: 'standard',            
          },
          InputPropsClasses:{
            underline: this.props.classes.customUnderline
          },
          onChange: (event) => this.onDropchanged(event, filter),          
          value: selectedValues,
          isMulti: filter.multipleSelection,          
        }}
        {...dataSource}
        {...this.props.customStore}
      />
    );
  };

  // handles change in the value of a dropdown filter
  onDropchanged = (value, filter) => {
    const predicate = filter.predicate.split(" ");
    predicate[2] = `${JSON.stringify(value.map((v) => v.label))}`;
    filter.predicate = predicate.join(" ");
    filter.isApplied = Boolean(value && value.length);
    this.updateFilter();
  };

  renderFilterItem = (filter) => {
    switch (filter.actionType) {
      case "switch":
        return this.renderSwitchFilter(filter);
      case "select":
        return this.renderDropdown(filter);
      case "timerange":
        return this.renderTimeRangeEditor(filter);
      case "daterange":
        return this.renderDateRangeFilter(filter);
      case "filter":
      default:
        return this.renderButtonFilter(filter);
    }
  };

  filterChange =
    (filter) =>
    ({ predicate, isApplied }) => {
      filter.isApplied = isApplied;
      filter.predicate = predicate;
      this.updateFilter();
    };

  renderDateRangeFilter = (filter) => {
    return <DateRange onClick={this.filterChange(filter)} filter={filter} />;
  };

  renderTimeRangeEditor = (filter) => {
    const predicate = filter.predicate.split(" ");
    const isInBetweenOperand = predicate.includes("inBetween");
    // This is to utilize the same time range input for multiple operand types like "InBetween","Lesser Than" and "GreaterThan" prsent in predicate.
    const time = isInBetweenOperand
      ? `${predicate[2].split("-")[0]} - ${predicate[2].split("-")[1]}`
      : `${predicate[2]} - ${predicate[6]}`;
    return (
      <TimeRange
        onClick={this.filterChange(filter)}
        filter={filter}
        defaultTime={time}
        isInBetweenOperand={isInBetweenOperand}
      />
    );
  };

  // Returns true if any individual filter within a group is Active
  isFilterGroupActive = (filterGroup) => {
    return filterGroup.filters.find((filter) => {
      if (filter.actionType === "switch") {
        return filter.options.find((option) => option.isApplied);
      } else {
        return filter.isApplied;
      }
    });
  };

  // Update the filter string in store based on active filters, which will trigger filter for shipments data
  updateFilter = () => {
    let quickFilter = appConstants.EMPTY_STRING;
    if (this.state.filterObject) {
      quickFilter = generateQuickFilterString(
        this.state.filterObject,
        this.props.userData.userProfile.planDate
      );
      this.setState((state) => ({
        filterObject: state.filterObject,
      }));
    }
    this.emitEvent("UpdateIBStore", "updateQuickFilter", quickFilter);

    quickFilter &&
      RMAXLogger.info("QuickFilter", {
        quickFilter: quickFilter,
        filterName: this.props.filterName,
      });
  };

  // removes all active filters
  onClear = () => {
    if (this.state.filterObject) {
      this.setState((state) => ({
        filterObject: clearFilter(state.filterObject),
      }));
      this.emitEvent(
        "UpdateIBStore",
        "updateQuickFilter",
        appConstants.EMPTY_STRING
      );
    }
  };

  emitEvent = (storeName, eventName, eventData) => {
    if (this.props.isStoreEvent) {
      this.props.glEventHub.emit(storeName, eventName, [eventData]);
    } else {
      this.props.glEventHub.emit(eventName, { eventData, filterName: this.props.filterName });
    }
  };

  // Toggles the visibility of quick filter panel
  toggleQuickFilterVisibility = (visible = null) => {
    const visibility = [true, false].includes(visible)
      ? visible
      : !this.state.quickFilterIsVisible;
    const width = visibility ? this.initialWidth : 40;
    this.props.glContainer.parent.container.setSize(width);

    this.setState({
      quickFilterIsVisible: visibility,
    });
  };

  //
  isAnyFilterApplied = () => {
    return (
      Object.keys(this.state.filterObject.filterGroups || {})
        .map((key) => {
          return this.isFilterGroupActive(
            this.state.filterObject.filterGroups[key]
          );
        })
        .filter((isActive) => isActive).length > 0
    );
  };

  render() {
    const { classes } = this.props;
    const { filterGroups } = this.state.filterObject || {};
    this.props.glContainer
      .getElement()
      .addClass(this.props.classes.quickFilterContainer);
    return this.state.quickFilterIsVisible ? (
      <Fragment>
        <header className={classes.header} data-automationid="quick-filter">
          <h3 className={classes.headerTitle}> Quick Filters </h3>
          <span className={classes.containerAction} onClick={this.onClear}>
            {" "}
            Clear All{" "}
          </span>
        </header>
        {this.state.isLoading ? (
          <div className={classes.message}>
            Please wait while loading filters
          </div>
        ) : (
          <div className={classes.container}>
            {this.state.filterObject ? (
              <List classes={{ root: classes.filterListContainer }}>
                {filterGroups ? (
                  Object.keys(filterGroups).map((filterGroupkey) => {
                    const filterGroup = filterGroups[filterGroupkey];
                    return (
                      <Fragment key={filterGroup.groupName}>
                        <ListItem
                          onClick={() =>
                            this.toggleFilterGroupVisibility({
                              groupKey: filterGroupkey,
                            })
                          }
                          classes={{ root: classes.filterGroupItem }}
                        >
                          <ListItemIcon
                            classes={{ root: classes.listItemIcon }}
                          >
                            {this.state[`${filterGroupkey}_isOpen`] ? (
                              <ExpandMore color="primary" />
                            ) : (
                              <ArrowRight color="primary" />
                            )}
                          </ListItemIcon>
                          <ListItemText
                            classes={{
                              root: classes.filterGroupTextRoot,
                              primary: classes.filterGroupText,
                            }}
                          >
                            {" "}
                            {filterGroup.groupName}{" "}
                          </ListItemText>
                          {this.isFilterGroupActive(filterGroup) &&
                            !this.state[`${filterGroupkey}_isOpen`] && (
                              <DotIcon
                                color="primary"
                                classes={{ root: classes.dotIcon }}
                              />
                            )}
                        </ListItem>
                        <Collapse
                          in={this.state[`${filterGroupkey}_isOpen`]}
                          classes={{
                            container: classes.collapseContainer,
                            wrapper: classes.filtersContainer,
                          }}
                        >
                          {filterGroup.filters &&
                            filterGroup.filters.map((filter) =>
                              <Fragment key={filter.label}>
                                {this.renderFilterItem(filter)}
                              </Fragment>
                            )}
                        </Collapse>
                      </Fragment>
                    );
                  })
                ) : (
                  <div className={classes.message}> No filters available </div>
                )}
              </List>
            ) : (
              <div className={classes.message}>
                {" "}
                Error while fetching quick filters
              </div>
            )}
          </div>
        )}

        <footer
          className={classes.footer}
          onClick={this.toggleQuickFilterVisibility}
        >
          <ArrowLeft classes={{ root: classes.footerIcon }} />
          <div className={classes.footerText}>Hide Quick Filters</div>
        </footer>
      </Fragment>
    ) : (
      <Fragment>
        <div
          className={classes.headerPanelcontainer}
          onClick={this.toggleQuickFilterVisibility}
        >
          Quick Filters{" "}
          {this.isAnyFilterApplied() && (
            <span className={classes.filterApplied}>- Filter Applied</span>
          )}
        </div>
        <footer
          className={classes.footer}
          onClick={this.toggleQuickFilterVisibility}
        >
          <Tooltip delay={500} title={"Show Quick Filters"}>
            <ArrowRight classes={{ root: classes.footerIcon }} />
          </Tooltip>
        </footer>
      </Fragment>
    );
  }
}

export default compose(withStyles(styles), withUserProfile, withTheme())(QuickFilter);
